import { Component } from '@angular/core';
import {  OnInit } from '@angular/core';
import { TweenLite} from 'gsap';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers : [] 
})
export class AppComponent {
  constructor(public http: HttpClient){
    
  }

  ngOnInit(): void {
    var profilePic = document.getElementById('profile-pic');
     //TweenLite.to(profilePic, 4, { ease: Bounce.easeOut, y: 10 });
    // TweenLite.to(profilePic, 2.8, { ease: Elastic.easeOut.config(1, 0.1), y: 10 });    
 }


 
}





// WEBPACK FOOTER //
// /Users/haydenso/Desktop/Code/Projects/haydensookchand/website_source/src/app/app.component.ts